/**
 * Whether the app's first route has already been shown.
 *
 * The splash belongs to the cold start — the static preboot in index.html and
 * the Suspense fallback that replaces it are one continuous screen. Every later
 * route is a navigation inside a panel the user is already looking at, so it
 * gets a skeleton instead. `PrebootDismisser` flips this as the first route
 * commits, which is the same moment the preboot starts to fade.
 */
let booted = false;

export const hasAppBooted = () => booted;

export const markAppBooted = () => {
  booted = true;
};
